<div class="row" *ngIf="taxStrategy">
  <div class="small-12 medium-12 columns">
    <div class="tax-strategy">
      <div foundation class="reports">
        <div class="row">
          <div class="medium-12 columns" style="padding: 0;">
            <ul class="reports tabs" data-tabs id="report-tabs" style="background: #F5F5F5;padding: 0;">
              <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'notes'}"><a id="a-notes"(click)="switchPage('notes')" aria-selected="true"><h6>Notes</h6></a></li>
              <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'opportunities'}"><a id="a-opportunities" (click)="switchPage('opportunities')" aria-selected="false"><h6>Opportunities</h6></a></li>
              <li class="reports tabs-title" [ngClass]="{'is-active': currentView == 'risks'}"><a id="a-risks" (click)="switchPage('risks')" aria-selected="false"><h6>Risks</h6></a></li>
            </ul>
          </div>
        </div>
        <div class="reports" data-tabs-content="report-tabs">
          <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'notes'" id="notes">
            <div class="row">
              <div class="small-12 medium-12 columns">
                <label class="strategy-view-label">Notes</label>
                <div class="strategy-view-content" *ngIf="!taxStrategy.description">No notes available for this strategy.</div>
                <div class="strategy-view-content" *ngIf="taxStrategy.description">
                  <app-tpiq-froala-view [data]="taxStrategy.description"></app-tpiq-froala-view>
                </div>
              </div>
            </div>
          </div>
          <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'opportunities'" id="opportunities">
            <app-tax-strategy-opportunities [taxStrategy]="taxStrategy"></app-tax-strategy-opportunities>
          </div>
          <div class="reports tabs-panel is-active tabs-content" style="padding: 20px;" *ngIf="currentView == 'risks'" id="risks">
            <app-tax-strategy-potential-risks [taxStrategy]="taxStrategy"></app-tax-strategy-potential-risks>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

